import { isNull } from 'lodash';
import { apiEndpoints } from '@utils';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class SignupService extends AbstractService {
	static setup(baseURL, options) {
		instance = new SignupService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoints = {
			signup       : `${apiEndpoints.clients}/signup`, // not sure this endpoint exists, couldn't find it in documentation
			prepaySignup : `${apiEndpoints.signUp}/client`,
			address      : `${apiEndpoints.signUp}/address`,
		};
	}

	static step1(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._step1(...params);
	}

	static clientSignup(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._clientSignup(...params);
	}

	static step2(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._step2(...params);
	}

	static prepaySignup(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._prepaySignup(...params);
	}

	static attachAddress(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._attachAddress(...params);
	}

	_clientSignup(data) {
		return this.request({
			endpoint : `${this.endpoints.prepaySignup}`,
			method   : 'POST',
			data,
		});
	}

	_step1({
		firstname, lastname, email, phoneno, company, password, confirmPassword,
	}, verifiedToken) {
		return this.request({
			endpoint : `${this.endpoints.signup}/step1`,
			method   : 'POST',
			data     : {
				FirstName         : firstname,
				LastName          : lastname,
				Email             : email,
				MobilePhone       : phoneno,
				CompanyName       : company,
				password,
				ConfirmPassword   : confirmPassword,
				ClientSignUpToken : verifiedToken,
			},
		});
	}

	_step2(signupToken, data) {
		return this.request({
			endpoint    : `${this.endpoints.signup}/step2`,
			method      : 'POST',
			data,
			queryParams : {
				token : signupToken,
			},
		});
	}

	_prepaySignup(data) {
		return this.post({
			endpoint : this.endpoints.prepaySignup,
			data,
		});
	}

	_attachAddress(signupToken, data) {
		return this.post({
			endpoint : `${this.endpoints.address}?token=${signupToken}`,
			data,
		});
	}
}
